import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { axiosApi } from "../../../constants/axios_api";
import appUrl from "../../../constants/appUrl";

const Budget = () => {
    const [totalBudget, setTotalBudget] = useState("");
    const [remainingBudget, setRemainingBudget] = useState("");
    const [cashbackBudget, setCashbackBudget] = useState("");
    const [budgetId, setBudgetId] = useState("");

    const getAllBudget = async () => {
        const response = await axiosApi.get(`${appUrl.baseUrl}api/prizeRouter/budget`);
        const budgetData = response?.data?.data;
        setBudgetId(budgetData?.[0]?._id || "");
        setTotalBudget(budgetData?.[0]?.totalBudget || "");
        setRemainingBudget(budgetData?.[0]?.remainingBudget || "");
        setCashbackBudget(budgetData?.[0]?.cashbackBudget || "");
    };

    useEffect(() => {
        getAllBudget();
    }, []);

    const handleBudgetSubmit = async () => {
        const budgetPayload = {
            totalBudget,
            remainingBudget,
            cashbackBudget,
        };

        try {
            const budgetResponse = await axiosApi.put(`${appUrl.baseUrl}api/prizeRouter/budget/${budgetId}`, budgetPayload);
            toast.success("Budget updated successfully");
        } catch (error) {
            console.error("Error updating budget:", error.response ? error.response.data : error.message);
            toast.error(error.response ? error.response.data.message : error.message);
        }
    };

    const handleKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode < 48 || charCode > 57) {
            e.preventDefault();
        }
    };

    return (
        <div className="custom-dialog">
            <h3>Budget</h3>
            <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <label>Total Budget</label>
                <InputText style={{ width: "100%" }} value={totalBudget} onChange={(e) => setTotalBudget(e.target.value)} onKeyPress={handleKeyPress} />
            </div>
            <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <label>Remaining Budget</label>
                <InputText style={{ width: "100%" }} value={remainingBudget} onChange={(e) => setRemainingBudget(e.target.value)} onKeyPress={handleKeyPress} />
            </div>
            <div className="p-field mt-3" style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <label>Cashback Budget</label>
                <InputText style={{ width: "100%" }} value={cashbackBudget} onChange={(e) => setCashbackBudget(e.target.value)} onKeyPress={handleKeyPress} />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Button label="Submit Budget" icon="pi pi-check" className="p-button-success mt-3" onClick={handleBudgetSubmit} />
            </div>
        </div>
    );
};

export default Budget;
